import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../i18n/LanguageContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DeleteAccountPage = () => {
  const { t } = useTranslation();
  const sections = t('pages.deleteAccount.sections', { returnObjects: true });

  return (
    <>
      <Header />
      <div className="min-h-screen bg-light-bg">
        {/* Header */}
        <section className="py-20 px-6 md:px-12 bg-gradient-to-b from-light-bg to-light-card">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="font-filson font-bold text-5xl md:text-6xl text-gray-900 mb-4">
              {t('pages.deleteAccount.title')}
            </h1>
            <p className="font-filson font-medium text-lg text-gray-600">
              {t('pages.deleteAccount.updated')}
            </p>
          </motion.div>
        </section>

        {/* Content */}
        <section className="py-20 px-6 md:px-12">
          <div className="max-w-4xl mx-auto">
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="font-filson font-medium text-base text-gray-600 leading-relaxed mb-12"
            >
              {t('pages.deleteAccount.intro')}
            </motion.p>

            <div className="space-y-6">
              {sections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.08 }}
                  viewport={{ once: true }}
                  className="card"
                  style={{
                    borderRadius: '12px',
                    border: '1px solid #E7EAE5',
                    padding: '24px',
                    backgroundColor: 'white',
                  }}
                >
                  <h2 className="font-filson font-bold text-xl text-gray-900 mb-3">
                    {section.title}
                  </h2>
                  {section.items ? (
                    <ul className="space-y-3">
                      {section.items.map((item, itemIndex) => (
                        <li key={itemIndex} className="font-filson font-medium text-gray-600 leading-relaxed">
                          <strong className="text-gray-900 underline">• {item.title}</strong>
                          {item.description && `: ${item.description}`}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="font-filson font-medium text-gray-600 leading-relaxed">
                      {section.content}
                    </p>
                  )}
                </motion.div>
              ))}
            </div>

            {/* Warning Box */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="mt-12 p-8 bg-red-50 rounded-card border-2 border-red-200"
              style={{ borderRadius: '12px' }}
            >
              <p className="font-filson font-bold text-red-700 mb-2">
                ⚠️ {t('pages.deleteAccount.agreement')}
              </p>
              <p className="font-filson font-medium text-sm text-red-600">
                {t('pages.deleteAccount.agreementText')}
              </p>
            </motion.div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default DeleteAccountPage;
